import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { showError } from '@utils';
import { b2bServices } from '@services';

import styles from './b2BOrderBookings.style';
import { CONTRACT_PERIODS } from '../constants';

const B2BAOrderBookingField = ({
  index,
  methods,
  isLoading,
  vehicles,
  onRemove,
}) => {
  const [isFetching, setIsFetching] = useState(false);

  const contractPeriod = methods.watch(
    `insertProducts.${index}.contractPeriod`
  );
  const vehicle = methods.watch(`insertProducts.${index}.vehicle`);
  const price = methods.watch(`insertProducts.${index}.price`);
  const discount = methods.watch(`insertProducts.${index}.discount`);

  const getProducts = async (catalogId, selectedContractPeriod) => {
    try {
      setIsFetching(true);
      const response = await b2bServices.getBookingProducts({
        catalogId,
        contractPeriod: selectedContractPeriod,
      });
      await methods.setValue(`insertProducts.${index}`, {
        ...response?.data?.[0],
        vehicle,
        price: response?.data?.[0]?.price.number,
        finalPrice: response?.data?.[0]?.price.number,
        customFields: {
          ...response?.data?.[0].customFields,
          contractPeriod: selectedContractPeriod,
        },
      });
    } catch (error) {
      showError(error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleChangeDiscount = (value) => {
    methods.setValue(`insertProducts.${index}.discount`, value);
    methods.setValue(
      `insertProducts.${index}.finalPrice`,
      (price - value * price).toFixed(2)
    );
  };

  const handleChangeFinalPrice = (value) => {
    methods.setValue(`insertProducts.${index}.finalPrice`, value);
    if (discount) {
      methods.setValue(`insertProducts.${index}.discount`, '');
    }
  };

  useEffect(() => {
    // console.log('vehicle', vehicle, contractPeriod);
    if (vehicle && contractPeriod) {
      getProducts(vehicle?.value, contractPeriod);
    }
    if (!vehicle) {
      methods.setValue(`insertProducts.${index}.contractPeriod`, '');
      methods.setValue(`insertProducts.${index}.price`, '');
      methods.setValue(`insertProducts.${index}.discount`, '');
      methods.setValue(`insertProducts.${index}.quantity`, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle, contractPeriod, index]);

  return (
    <Box sx={styles.row}>
      <Box sx={styles.removeBtn}>
        <ButtonV2 onClick={() => onRemove(index)} variant="text" color="error">
          <DeleteIcon sx={styles.icon} />
        </ButtonV2>
      </Box>
      <FieldV2
        isRequired
        control={methods.control}
        name={`insertProducts.${index}.vehicle`}
        type="autocomplete"
        label="Vehicle"
        options={vehicles}
        disabled={isLoading || isFetching}
      />
      <FieldV2
        isRequired
        control={methods.control}
        name={`insertProducts.${index}.contractPeriod`}
        type="dropdown"
        label="Contract Period"
        options={CONTRACT_PERIODS}
        disabled={isLoading || isFetching}
      />
      <FieldV2
        isRequired
        control={methods.control}
        name={`insertProducts.${index}.quantity`}
        type="number"
        label="Quantity"
        disabled={isLoading || isFetching}
        min="0"
      />
      <FieldV2
        control={methods.control}
        name={`insertProducts.${index}.discount`}
        type="number"
        max="1"
        step="any"
        label="Discount"
        disabled={isLoading || isFetching}
        onChange={handleChangeDiscount}
      />
      <FieldV2
        isRequired
        control={methods.control}
        name={`insertProducts.${index}.finalPrice`}
        type="number"
        label={
          <Box sx={styles.priceLabel}>
            <Box sx={{ width: '76px' }}>Final Price</Box>
            {price ? (
              <Box component="small" sx={{ minWidth: '110px' }}>
                (Init. Price:
                {price})
              </Box>
            ) : (
              ''
            )}
          </Box>
        }
        disabled={isLoading || isFetching}
        onChange={handleChangeFinalPrice}
      />
    </Box>
  );
};

export default B2BAOrderBookingField;
